import { useRouter } from 'next/router'
import { useMutationNext } from './hooksF/useQueryNextF'
import { useEffect } from 'react'
import * as _ from 'lodash-es'
import { gql } from '@apollo/client'
import { jsErrSym } from '../sharedF/throwErrorF/constantsF.mts'
const FakeExceptionMut = gql`mutation ($gpVersion: String) {
  gmGenTestGqlException(gpVersion: $gpVersion)
}`

export const ManualClientSideExceptionWrap = ({children}) => {
  const {query: {version}} = useRouter()
  const gpVersion = _.isArray(version) ? version[0] : version
  const [doSend] = useMutationNext(FakeExceptionMut)

  useEffect(() => {
    if (gpVersion) {
      doSend({variables: {gpVersion}})
    }
    return () => {}
  }, [gpVersion])

  // triggers ReportJsErrMut, not FakeExceptionMut
  const isTrigger = _.startsWith(gpVersion ?? '', jsErrSym)
  if (isTrigger) {
    const itsNull = /** @type {any} */ (null)
    const {gpUrl} = itsNull
    console.log({gpUrl})
  }

  return children
}